/** Pack four skin weights into unorm8 without wrapping an empty first slot to 255. */
export function writeSkinWeights(source:ArrayLike<number>|null,sourceOffset:number,target:Uint8Array,targetOffset:number):void {
  let total=0, largest=0, largestWeight=0;
  for(let k=0;k<4;k++) {
    const raw=source?.[sourceOffset+k]??(k===0?1:0);
    const weight=Number.isFinite(raw)?Math.max(0,raw):0;
    total+=weight;
    if(weight>largestWeight){largest=k;largestWeight=weight;}
  }
  if(!Number.isFinite(total)||total<=0){target.set([255,0,0,0],targetOffset);return;}
  let packedTotal=0;
  for(let k=0;k<4;k++) {
    const raw=source?.[sourceOffset+k]??(k===0?1:0);
    const weight=Number.isFinite(raw)?Math.max(0,raw):0;
    const packed=Math.round(weight/total*255);
    target[targetOffset+k]=packed;packedTotal+=packed;
  }
  // The largest of four normalized weights has at least 64 packed units;
  // the rounding residual is at most two, so this cannot underflow.
  target[targetOffset+largest]+=255-packedTotal;
}
